export default {
	"fca1": "FCA 유동성 청산 계정 개설 프로세스",
	"fca1-m": "FCA 유동성 청산 계정 개설 프로세스",
	"fca2": "EBC Financial Group (UK) Ltd는 영국 FCA(Financial Conduct Authority)의 승인 및 규제를 받는 종합 금융 증권 회사입니다. 레퍼런스 번호: 927552",
	"fca3": "유럽 ​​연합의 \"금융상품투자지침(MiFID)\" 및 후속 개정판인 MiFID II는 고객의 지식수준, 경험 및 전문성에 따라 \"소매 투자자\" 또는 \"전문 투자자\"로 분류합니다.<br><br>FCA 규정에 따라 EBC Financial Group Limited는 전문 투자자와 기관 투자자에게만 허용되며 레버리지 100배의 FCA 유동성 청산계정을 개설할 수 있습니다. 투자자 자금은 바클레이은행 계좌에 독립적으로 예탁됩니다.",
    "fca4":{
		"title":"전문 투자자는 다음 세 가지 기준 중 두 가지를 충족해야 합니다.",
		"title-m":"전문 투자자는 다음 세 가지 기준 중 두 가지를 충족해야 합니다.",
		"desc":"지난 1년간 평균 거래횟수 분기당 10회 달성",
		"desc1":"현금 저축 및 금융 상품으로 구성된 €500,000 이상의 투자 포트폴리오 보유",
		"desc2":"금융업에 종사하거나 최소 1년 이상 근무 경험 보유, CFD 혹은  파생상품 거래의 이해"
	},
	"fca5":{
		"title":"FCA 유동성 청산 계정 개설 프로세스",
		"desc":"신청서 다운로드 및 작성",
		"desc1":"서류 준비 및 인증",
		"desc2":"서류제출 및 이메일 접수",
		"desc3":"규정 준수 검토 및 문서 서명",
		"desc4":"FCA 계좌 개설 및 계좌 설정",
		"btn":"전문 투자자 신청서 다운로드",
		"btn1":"기관 투자자 신청서 다운로드"
	},
	"fca6":{
		"title":"FCA 계좌를 개설하면 가장 권위 있는 관리 감독과 가장 안전한 금융 보호를 받을 수 있습니다. 지금 바로 개설하세요.",
		"title-m":"FCA 유동성 청산 계정 개설",
		"desc":"영국 금융감독청(FCA)",
		"desc1":"FCA 유동성 청산 계정 상담 이메일:",
		"desc2":""
	},
	"lang":"en",
	FCA流动性清算账户开设流程: `FCA  계좌 개설 절차`,
	"EBC Financial Group Limited是受英国金融市场行为管理局（FCA）授权并监管的综合金融券商":
	  "EBC Financial Group (UK) Ltd는 영국 금융 감독청(FCA) 의 승인 및 규제를 받는 종합 금융 증권사이며, 모든 거래 주문은 국제 청산 풀로 직접 전달됩니다.  라이선스 번호: 927552",
	"在EBC Financial Group Limited开设FCA流动性清算账户":
	  "EBC Financial Group (UK) Ltd에서 FCA 계좌를 개설할 경우, FSCS 배상 조항에 따라 최대 85000파운드의 배상을 요구할 권리가 있습니다.",
	"欧盟《金融工具市场法规（MiFID）》及其后修订版MiFID": `EU의 금융상품시장지침(MiFID)과 그 수정인 MiFID II는 고객의 지식, 경험, 전문성 수준에 따라 '개인투자자'와 '전문투자자'로  구분하고 있습니다. `,
	根据FCA法规: `FCA 규정에 따라 당사는 EBC Financial Group (UK) Ltd의 FCA 계좌는 전문투자자와 기관투자자에 한해 개설할 수 있습니다. 레버리지는 최대 100배로 설정할 수 있으며, 투자자의 자금은 바클레이 은행에 독립적으로 보관됩니다.`,
	专业投资者须满足以下三个标准中的其中两个: `전문투자자는 다음 세 개의 조건 중 2개를 충족해야 합니다`,
	"过去一年平均交易频率达到10次/季度": "지난 1년간 분기별 평균 거래 횟수 10회 이상",
	持有超过50万欧元的投资组合:
	  "현금, 예금 및 기타 금융상품의 총액 50만 유로 이상",
	在金融行业工作或至少工作过一年:
	  "금융업계 근무 경험 1년 이상, CFD(차액결제거래) 및 금융파생상품 거래에 대한 충분한 지식 보유",
	FCA流动性清算账户开户流程: `FCA  계좌 개설 절차`,
	获取申请表: "신청서 다운로드",
	访EBC英国站: "EBC UK에서 신청서 다운받기",
	提交材料: "KYC 제출",
	按要求填写: "양식 작성 후 KYC 서류 업로드",
	合规审核: "온보딩 심사",
	等待合规审核: "서류 검토 완료 후 서명 진행",
	开户成功: "개좌 개설 성공",
	登录并设置您的FCA账户: "FCA 계좌로 로그인 후 설정 완료",
	最权威的监管保护和最安全的: `FCA 계좌 개설<br />
				  가장 권위 있는 규제 기관과 가장 안전한 금융 보증`,
	"英国金融市场行为管理局（FCA）": "영국 금융감독청(FCA)",
	FCA流动性清算账户咨询邮箱: `FCA 계좌 개설 상담 이메일: 
					  <a href="mailto:support@ebcfin.co.uk">support@ebcfin.co.uk</a>`,
}

